/**
 * 서비스 브랜드 설정
 * 서비스명을 변경하려면 이 파일만 수정하면 됩니다. (예: "오늘은 뭐먹지?")
 */
export const BRAND = {
  name: '오늘 뭐먹지?',
  nameEn: 'What to Eat Today',
  slogan: '오늘 점심, 고민하지 말고 함께 정하자!',
  subtitle: '점심 메뉴 고민은 이제 그만!\n동료들과 함께 쉽고 재미있게 결정하세요.',
  pageTitle: '오늘 뭐먹지? | 직장인 점심 메뉴 함께 정하기',
  /** 문의·개인정보 관련 연락처 (개인정보처리방침에 표시됨) */
  contactEmail: 'contact@momeokji.kr',
  /** 개인정보처리방침 시행일 */
  privacyEffectiveDate: '2026-10-15',
  description:
    '오늘 점심 뭐 먹지? 동료들과 링크 하나로 모여 배달, 외식부터 최종 메뉴까지 쉽고 재미있게 결정하는 점심 메뉴 선택 서비스.',
} as const;
